/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

/**
 * stripTags - A dumb filter to remove HTML tags from a string.
 * @memberof SOGo.Common
 */
(function () {
  'use strict';

  /**
   * @ngInject
   */
  function stripTags() {
    return function(text) {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

  angular.module('SOGo.Common')
    .filter('stripTags', stripTags);
})();
